import { useQuery } from "@tanstack/react-query";
import { INTERVAL } from "../../constants/clientTime";
import { getGraphDisplayNames } from "./core.service";

export function useGraphDisplayNames(emails: string[]) {
  const sortedEmails = [...new Set(emails)].sort();

  return useQuery({
    queryKey: ["graphDisplayNames", sortedEmails],
    queryFn: () => getGraphDisplayNames(sortedEmails),
    enabled: sortedEmails.length > 0,
    refetchOnWindowFocus: false,
    staleTime: 1 * INTERVAL.DAY,
    gcTime: 1 * INTERVAL.DAY, // ponytail: keep in sync with staleTime
  });
}
